"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncAppValidationStatus = void 0;
/**
 * Async app validation status
 */
var AsyncAppValidationStatus;
(function (AsyncAppValidationStatus) {
    AsyncAppValidationStatus["Created"] = "Created";
    AsyncAppValidationStatus["InProgress"] = "InProgress";
    AsyncAppValidationStatus["Completed"] = "Completed";
    AsyncAppValidationStatus["Aborted"] = "Aborted";
})(AsyncAppValidationStatus || (exports.AsyncAppValidationStatus = AsyncAppValidationStatus = {}));
//# sourceMappingURL=AsyncAppValidationResponse.js.map